import {
  LatLng,
  getDefaultLatLng,
} from '@porterin/booking-flow/src/order-review/domain/entities/LatLng';

export interface ExtendedAddressDetails {
  state?: string;
  city?: string;
  pincode?: string;
  locality?: string;
  subLocality?: string;
}

export const getDefaultExtAddressDetails = (): ExtendedAddressDetails => ({});

export interface ExtendedAddress {
  landmark: string;
  location: LatLng;
  addressDetails: ExtendedAddressDetails;
}

export const getDefaultExtAddress = (): ExtendedAddress => ({
  landmark: '',
  location: getDefaultLatLng(),
  addressDetails: getDefaultExtAddressDetails(),
});
